export default __webpack_public_path__ + "static/media/13.53399033.jpg";